// extracted by mini-css-extract-plugin
export default {"root":"root___GccP8","title":"title___dDJ50","hr":"hr___r4tFi"};